const removeAllNoneNumbers = (number: string) => number.replace(/[^0-9]+/g, '');

export default removeAllNoneNumbers;
